
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Index from './pages/Index';
import Dashboard from './pages/Dashboard';
import TeamAnalysis from './pages/TeamAnalysis';
import Coaching from './pages/Coaching';
import NotFound from './pages/NotFound';
import AiChat from './pages/AiChat';
import AiRolePlay from './pages/AiRolePlay';
import Onboarding from './pages/Onboarding';
import ModuleContent from './pages/ModuleContent';
import KnowledgeBase from './pages/KnowledgeBase';
import Settings from './pages/Settings';
import Billing from './pages/Billing';
import PersonalizeOutreach from './pages/PersonalizeOutreach';
import EmailSequence from './pages/EmailSequence';
import Voice from './pages/Voice';
import People from './pages/People';
import Contacts from './pages/Contacts';
import Pipeline from './pages/Pipeline';
import ResetPassword from './pages/ResetPassword';

function App() {
  return (
    <Router>
      <Toaster richColors />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/team-analysis" element={<TeamAnalysis />} />
        <Route path="/coaching" element={<Coaching />} />
        <Route path="/ai-chat" element={<AiChat />} />
        <Route path="/ai-role-play" element={<AiRolePlay />} />
        <Route path="/voice" element={<Voice />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/onboarding/module/:moduleId" element={<ModuleContent />} />
        <Route path="/knowledge-base" element={<KnowledgeBase />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/personalize-outreach" element={<PersonalizeOutreach />} />
        <Route path="/email-sequence" element={<EmailSequence />} />
        <Route path="/people" element={<People />} />
        <Route path="/crm/contacts" element={<Contacts />} />
        <Route path="/crm/pipeline" element={<Pipeline />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
